export default {
  name  : 'panelDivider',
  props : {
    titlePage    : String,
    subtitlePage : String,
    useDivider   : {
      type    : Boolean,
      default : false
    },
    showTitle: {
      type    : Boolean,
      default : true
    }
  }
};
